import { Timestamp } from 'firebase/firestore';

export const dateToFirestoreTimestamp = (obj: any): any => {
  if (obj instanceof Date) {
    return Timestamp.fromDate(obj);
  }

  if (Array.isArray(obj)) {
    return obj
      .map((item) => dateToFirestoreTimestamp(item))
      .filter((item) => item !== undefined);
  }

  if (obj !== null && typeof obj === 'object') {
    const transformedObj: { [key: string]: any } = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const val = dateToFirestoreTimestamp(obj[key]);
        if (val !== undefined) {
          transformedObj[key] = val;
        }
      }
    }
    return transformedObj;
  }

  return obj;
};
